import React, { useEffect, useState } from 'react';
import Icon from '@/components/Icon';
import { ApiError, api } from '@/lib/api';

/**
 * Создание / редактирование временного интервала внеурочных занятий.
 * Никаких особенностей по сравнению с интервалами доп. занятий —
 * просто отдельная сущность с собственным API.
 */
const EMPTY = { timeStart: '', timeEnd: '', archive: false };

function shortTime(t) { return (t || '').slice(0, 5); }

export default function ExtracurricularTimeEditModal({ mode, time, onClose, onSaved }) {
  const [data, setData]     = useState(EMPTY);
  const [saving, setSaving] = useState(false);
  const [error, setError]   = useState(null);

  useEffect(() => {
    if (mode === 'edit' && time) {
      setData({
        timeStart: shortTime(time.timeStart),
        timeEnd:   shortTime(time.timeEnd),
        archive:   !!time.archive,
      });
    } else {
      setData(EMPTY);
    }
  }, [mode, time?.id]);

  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape' && !saving) onClose(); };
    window.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    return () => {
      window.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
    };
  }, [onClose, saving]);

  const set = (k, v) => setData((d) => ({ ...d, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true); setError(null);
    try {
      const payload = {
        timeStart: data.timeStart,
        timeEnd:   data.timeEnd,
        archive:   data.archive,
      };
      const res = mode === 'create'
        ? await api.post('/api/extracurricular-times', payload)
        : await api.put(`/api/extracurricular-times/${time.id}`, payload);
      onSaved?.(res.time);
      onClose();
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Не удалось сохранить');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="sd-overlay" onClick={(e) => { if (e.target.classList.contains('sd-overlay') && !saving) onClose(); }}>
      <div className="sd-modal sd-modal--narrow" role="dialog" aria-modal="true" style={{ maxWidth: 420 }}>
        <div className="sd-edit__head">
          <h2>{mode === 'create' ? 'Новый временной интервал' : 'Редактирование интервала'}</h2>
          <button className="sd-close" onClick={onClose} disabled={saving}><Icon name="x" size={14} /></button>
        </div>

        <form onSubmit={submit} className="sd-edit__form" noValidate>
          <div className="sd-edit__body">
            <div className="sd-edit__field">
              <label className="sd-edit__label">Начало *</label>
              <input
                className="sd-edit__input"
                type="time"
                value={data.timeStart}
                onChange={(e) => set('timeStart', e.target.value)}
                required
                autoFocus
              />
            </div>
            <div className="sd-edit__field">
              <label className="sd-edit__label">Окончание *</label>
              <input
                className="sd-edit__input"
                type="time"
                value={data.timeEnd}
                onChange={(e) => set('timeEnd', e.target.value)}
                required
              />
            </div>

            <div className="sd-edit__field sd-edit__field--full">
              <label className="ref-checkbox">
                <input
                  type="checkbox"
                  checked={data.archive}
                  onChange={(e) => set('archive', e.target.checked)}
                />
                <span>В архиве (скрыт из выпадашек)</span>
              </label>
            </div>
          </div>

          <div className="sd-edit__foot">
            {error && <div className="sd-edit__error">{error}</div>}
            <div className="sd-edit__foot-spacer" />
            <button type="button" className="btn btn--sm" onClick={onClose} disabled={saving}>Отмена</button>
            <button type="submit" className="btn btn--primary btn--sm" disabled={saving}>
              {saving ? 'Сохраняем…' : (mode === 'create' ? 'Создать' : 'Сохранить')}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
